module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-17-a1b3d0066ee081a7bb945ac524dff9a1.jpg";